<template>
  <div class="modal fade bd-example-modal-lg" id="sailProformaStatusPopup" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
        <div class="modal-header">
          <h3 class="title mb-2 ml-3">Sefer Proforma Durumu</h3>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" class="la la-close"></span>
          </button>
        </div>
        <div class="modal-body" v-if="agencyMap">
            <div class="contact-form-action">
              <div class="col-lg-12">
                <div class="card-item" v-if="sailAgencyProformaStatusList != null">
                  <div class="row">
                    <div class="contact-form-action col-sm-4">
                      <div class="input-box" >
                        <label class="font-weight-bold label-text">Acente Adı</label>
                      </div>
                    </div>
                    <div class="contact-form-action col-sm-2">
                      <div class="input-box" >
                        <label class="font-weight-bold label-text">Durumu</label>
                      </div>
                    </div>
                    <div class="contact-form-action col-sm-2">
                      <div class="input-box" >
                        <label class="font-weight-bold label-text">Aktar</label>
                      </div>
                    </div>
                    <div class="contact-form-action col-sm-2">
                      <div class="input-box" >
                        <label class="font-weight-bold label-text">İndir</label>
                      </div>
                    </div>
                    <div class="contact-form-action col-sm-2">
                      <div class="input-box" >
                        <label class="font-weight-bold label-text">Üretim Tarihi</label>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-for="proformaStatus in sailAgencyProformaStatusList">
                    <div class="contact-form-action col-sm-4">
                      <div class="input-box" >
                        <label class="label-text">{{agencyMap[proformaStatus.agencyId].name}}</label>
                      </div>
                    </div>
                    <div class="contact-form-action col-sm-2">
                      <div class="input-box" >
                        <label class="label-text" :class="getStatusClass(proformaStatus.status)">{{getStatusText(proformaStatus.status)}}</label>
                      </div>
                    </div>
                    <div class="contact-form-action col-sm-2">
                      <div class="input-box" v-if="proformaStatus.status !== 'ok'">
                        <a @click="createNewProforma(proformaStatus.agencyId, proformaStatus.sailId)" class="a-logo-export">Yarat</a>
                      </div>
                      <div class="input-box" v-if="proformaStatus.status === 'ok'">
                        <a @click="createNewProforma(proformaStatus.agencyId, proformaStatus.sailId)" class="a-logo-export">Tekrar Yarat</a>
                      </div>
                    </div>
                    <div class="contact-form-action col-sm-2">
                      <div class="input-box" v-if="proformaStatus.status === 'ok'">
                        <a @click="downloadProforma(proformaStatus.agencyProforma.documentStoreId)" class="a-logo-export">indir</a>
                      </div>
                    </div>
                    <div class="contact-form-action col-sm-2">
                      <div class="input-box" >
                        <label class="label-text" v-if="proformaStatus.agencyProforma">{{proformaStatus.agencyProforma.createDate | ddMMyyyyHHmmSS }}</label>
                        <label class="label-text" v-else> - </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="contact-form-action ml-4">
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import messagePopupManager from "../../util/messagePopupManager";

export default {
  name: "SailProformaStatusPopup",
  data:function (){
    return{
      loading:false
    }
  },
  computed:{
    agencyList:{
      get(){
        return this.$store.getters.getAgencyList
      }
    },
    sailAgencyProformaStatusList:{
      get(){
        return this.$store.getters.getSailAgencyProformaStatusList
      }
    },
    agencyMap:{
      get(){
        return this.$store.getters.getAgencyListMap;
      }
    },
    sail:{
      get(){
        return this.$store.getters.getSail;
      }
    }
  },
  methods:{
    downloadProforma : function (id){
      this.$store.dispatch("downloadProforma", {id: id});
    },
    createNewProforma : function (agencyId, sailId){
      this.$store.dispatch("generateProforma", {agencyId: agencyId, sailId: sailId }).then((response)=>{
        this.sailAgencyProformaStatusList.forEach(sailAgencyProformaStatus => {
          if(sailAgencyProformaStatus.agencyId === agencyId){
            sailAgencyProformaStatus.agencyProforma = response;
            sailAgencyProformaStatus.status = 'ok';
          }
        })
      }).catch(error => {
        messagePopupManager.showError("Hata", error.response.data.message);
      });
    },
    getStatusClass(status){
      switch (status){
        case "ok" : return "status-ok";
        case "none" : return "status-none";
      }
    },
    getStatusText(status){
      switch (status){
        case "ok" : return "üretildi";
        case "none" : return "beklemede";
      }
    }
  },
  updated() {
    setTimeout(function () {
      $(".select-contain-select").selectpicker('refresh');
    }, 100);
    $(".select-contain-select").selectpicker({
      size: 5,
      noneSelectedText: 'Select One'
    });
  }
}
</script>

<style scoped>
.a-logo-export{
  cursor: pointer;
  color: #0d47a1;
}

.contact-form-action{
  padding: 0!important;
}

.status-failed{
  color: #e53935;
}

.status-ok{
  color: #0da33e;
}

.status-none{
  color: #9e9d24;
}

</style>